// Dashboard numbers in the app's usual form: 20652 → "20 652" (pl-PL groups from five digits).
const formatter = new Intl.NumberFormat('pl-PL');

export const formatCount = (value: number | string): string => formatter.format(Number(value) || 0);
